var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVFil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m33.974 29.426-.677 3.517 6.431.879-.451 1.648-6.318-.879c-.451 1.429-.677 2.968-1.241 4.286-.564 1.539-1.128 3.078-1.805 4.506-.903 1.868-2.482 3.187-4.626 3.517-1.24.22-2.595.11-3.61-.66-.338-.22-.677-.659-.677-.989 0-.44.226-.989.564-1.208.226-.11.79 0 1.128.11.339.33.677.769.903 1.208.677.88 1.58.99 2.482.33 1.015-.88 1.58-2.088 1.918-3.297.677-2.637 1.354-5.165 1.918-7.803v-.44l-5.98-.878.226-1.649 6.205.88.79-3.408-6.43-.989.225-1.758 6.656.88c.226-.66.339-1.21.564-1.76.564-1.977 1.128-3.956 2.482-5.714 1.354-1.758 2.934-2.857 5.303-2.747 1.015 0 2.03.33 2.707 1.099.113.11.339.33.339.549 0 .44 0 .99-.339 1.319-.45.33-1.015.22-1.466-.22-.339-.33-.564-.66-.903-.99-.677-.878-1.692-.988-2.482-.219-.564.55-1.128 1.319-1.466 2.088-.79 2.308-1.354 4.726-2.144 7.144l6.205.879-.451 1.648-5.98-.879Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVFil);
export default __webpack_public_path__ + "static/media/vFil.11a2ff73dde5e54d9c289d5030a2f7fe.svg";
export { ForwardRef as ReactComponent };